import bairro from './bairro'
import cliente from './cliente'
import empresa from './empresa'
import estado from './estado'
import funcionalidade from './funcionalidade'
import logradouro from './logradouro'
import logradouroTipo from './logradouro-tipo'
import modulo from './modulo'
import municipio from './municipio'
import notaVersao from './nota-versao'
import pais from './pais'
import ramoAtividade from './ramo-atividade'
import sistema from './sistema'
import usuario from './usuario'

export default [
    {
        meta: {authenticated: true, layout: 'admin'},
        path: '/cadastro',
        component: () => import('@/views/cadastro/Index'),
        children: [
            ...bairro,
            ...cliente,
            ...empresa,
            ...estado,
            ...funcionalidade,
            ...logradouro,
            ...logradouroTipo,
            ...modulo,
            ...municipio,
            ...notaVersao,
            ...pais,
            ...ramoAtividade,
            ...sistema,
            ...usuario,
        ],
    },
]